module.exports = __webpack_public_path__ + "img/logo.052ea581.png";